import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import * as moment from 'moment';
import { ProductService } from 'src/app/shared/services/product.service';
import { take } from 'rxjs/operators';

@Component({
	selector: 'app-place-info',
	templateUrl: './place-info.component.html',
	styleUrls: ['./place-info.component.scss']
})
export class PlaceInfoComponent implements OnInit {
	toppingForm: FormGroup;
	submitted = false;
	placeInfo = null;
	placeInfoGroup: FormGroup;
	constructor(private producService: ProductService, private formBuilder: FormBuilder) { }

	ngOnInit() {
		this.producService.getPlaceInfo().valueChanges().pipe(take(1)).subscribe(placeInfo => {
			this.placeInfo = placeInfo;
			this.placeInfoGroup = this.formBuilder.group({
				address: [this.placeInfo.address, Validators.required],
				placeName: [this.placeInfo.placeName, Validators.required],
				phone: [this.placeInfo.phone, [Validators.required]],
				taOpenTime: [this.placeInfo.taOpenTime, [Validators.required]],
				taCloseTime: [this.placeInfo.taCloseTime, [Validators.required]],
				taActive: [this.placeInfo.taActive, [Validators.required]],
				deliveryOpenTime: [this.placeInfo.deliveryOpenTime, [Validators.required]],
				deliveryCloseTime: [this.placeInfo.deliveryCloseTime, [Validators.required]],
				deliveryActive: [this.placeInfo.deliveryActive, [Validators.required]],
				phoneNotification: [this.placeInfo.phoneNotification, [Validators.required]],
				logo: [this.placeInfo.logo],
			}, {
			});
		});
	}
	get f() { return this.placeInfoGroup.controls; }

	onSubmit() {
		this.submitted = true;
		// stop here if form is invalid
		if (this.placeInfoGroup.invalid) {
			return;
		}
		this.producService.updatePlaceInfo(this.placeInfoGroup.value)
	}


}
